import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    rect: null,
    show: { type: Boolean },
    showToSide: { type: Boolean },
    width: null,
    height: null
  },
  setup(__props: any) {

const props = __props as {
  rect: DOMRect | null;
  show: boolean;
  showToSide?: boolean;
  width?: number;
  height?: number;
}

const margin = 10;

const keepShowing = ref(false);
const showOnTop = computed(() => {
  if (!props.rect || props.showToSide) return false;
  return (
    props.rect.y - 0 > window.innerHeight - (props.rect.y + props.rect.height)
  );
});
const showOnLeft = computed(() => {
  if (!props.rect || !props.showToSide) return false;
  return (
    props.rect.x - 0 > window.innerWidth - (props.rect.x + props.rect.width)
  );
});
const x = computed(() => {
  if (!props.rect) return 0;
  if (props.showToSide) {
    return showOnLeft.value
      ? props.rect.x - margin
      : props.rect.x + props.rect.width + margin;
  }
  return props.rect.x;
});
const y = computed(() => {
  if (!props.rect) return 0;
  if (props.showToSide) {
    return props.rect.y;
  }
  return showOnTop.value
    ? props.rect.y - margin
    : props.rect.y + props.rect.height + margin;
});
const width = computed(() => props.width ?? props.rect?.width ?? 0);
const maxHeight = computed(() => {
  if (!props.rect) return 0;
  if (showOnTop.value) {
    return Math.max(0, props.rect.y - 0 - margin * 2);
  }
  return Math.max(
    window.innerHeight - (props.rect.y + props.rect.height) - margin * 2
  );
});
const height = computed(() => {
  if (props.showToSide) {
    return `${props.height ?? 100}px`;
  }
  return props.height ? `${props.height}px` : "auto";
});
const transform = computed(() => {
  if (props.showToSide) {
    if (showOnLeft.value) {
      return "translateX(-100%)";
    }
    return "none";
  }
  if (showOnTop.value) {
    return "translateY(-100%)";
  }
  return "none";
});
const pointerenter = () => {
  keepShowing.value = true;
};
const pointerleave = () => {
  keepShowing.value = false;
};

return (_ctx: any,_cache: any) => {
  return (__props.show || keepShowing.value)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: ".app"
      }, [
        _createElementVNode("div", {
          class: "tooltip",
          style: _normalizeStyle({
        top: `${_unref(y)}px`,
        left: `${_unref(x)}px`,
        width: `${_unref(width)}px`,
        maxHeight: `${_unref(maxHeight)}px`,
        height: _unref(height),
        transform: _unref(transform),
      }),
          onPointerenter: pointerenter,
          onPointerleave: pointerleave
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 36)
      ]))
    : _createCommentVNode("", true)
}
}

})